import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'sa-product-import-error-overview',
    template: require('./product-import-error-overview.component.html'),
})
export class ProductImportErrorOverviewComponent {

    constructor(
        public dialogRef: MatDialogRef<ProductImportErrorOverviewComponent>,
        @Inject(MAT_DIALOG_DATA) public message: any) { }

    onClick(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/product-import-error-overview/product-import-error-overview.component.ts